<template>
 <div id="notification-list-item">
	 <div :class="notification.status === 'read'? 'read': 'unread'">
		<div class="container-fluid increased-padding">
			<div class="sender-details">
				<div>
					<span class="name-field">{{notification.user_name}}</span>
					<span v-if="notification.user_job" class="job-field">-{{notification.user_job}}</span>
				</div>
				<div class="header">
					<span class="date-field">{{ notification.created_at | moment("YYYY-MM-DD HH:mm")}}</span>
				</div>
				<span class="message-field">
					<span>{{ notification.message}}</span>
				</span>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
 </div>
</template>

<script>
export default {
	name: "NotificationItem",
  props: {
		notification: {
			type: Object,
			required: true
		}
  },
  methods: {
	},
	created() {
	},
  computed: {
  }
};
</script>

<style lang="scss" scoped>
#notification-list-item {
	.unread {
		background: var(--main-color)16;
	}
	border-bottom: solid 1px #f1f1f3;
	.header {
		padding-bottom: 20px;
	}
	.name-field {
		font-weight: bold;
	}
	.name-field, .job-field, .message-field {
		font-size: 15px;
	}
}
.increased-padding {
	padding: 20px;
}
.modal-body {
	padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/notifications/NotificationListItem.vue